<template>
  <div id="my-images">
    <!-- HEADER -->
    <section class="pt-lg-5 py-4">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <section-header
              title="MY ARTWORK"
              subtitle="Claimed Images & Animations"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- IMAGES -->
    <section class="pb-5">
      <div class="container">
        <div class="row">
          <div class="images-wrapper col-12">
            <div v-if="user.claimedImages.length > 0">
              <div
                v-if="user.claimedImages.length > 0"
                class="row artwork-section-header mt-4"
              >
                <div
                  class="artwork-section-content col-12 d-flex justify-content-between align-items-center"
                >
                  <div>
                    <h4 class="m-0">
                      IMAGES ({{ user.claimedImages.length }})
                    </h4>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  v-for="artwork in user.claimedImages"
                  :key="'claimed-artwork-' + artwork.id"
                  class="col-lg-3 col-md-4 col-6"
                >
                  <artwork-card
                    :username="artwork.artist_handle"
                    :thumbnail="artwork.url_path"
                    :artworkId="artwork.id"
                    :price="artwork.price"
                    :proFilePrice="artwork.pro_file_price"
                    :proFile="artwork.pro_file_sold > 0 ? true : false"
                    :proFileSold="artwork.pro_file_sold > 0 ? true : false"
                    :isVerified="artwork.is_verified === '1' ? true : false"
                    :termLicenseCreated="artwork.term_license_created"
                    :termLicenseStatus="artwork.term_license_status"
                    :termLicenseType="artwork.term_license_type"
                    :termLicenseExpires="artwork.license_expire_date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="images-wrapper col-12">
            <div v-if="user.claimedAnimations.length > 0">
              <div
                v-if="user.claimedAnimations.length > 0"
                class="row artwork-section-header mt-4"
              >
                <div
                  class="artwork-section-content col-12 d-flex justify-content-between align-items-center"
                >
                  <div>
                    <h4 class="m-0">
                      ANIMATIONS ({{ user.claimedAnimations.length }})
                    </h4>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  v-for="animation in user.claimedAnimations"
                  :key="'claimed-animation-' + animation.id"
                  class="col-lg-3 col-md-4 col-6"
                >
                  <artwork-card
                    :username="animation.artist_handle"
                    :thumbnail="animation.url_path"
                    :artworkId="animation.id"
                    :poster="animation.poster_url_path"
                    :price="animation.price"
                    type="animation"
                    :isVerified="animation.is_verified === '1' ? true : false"
                    :termLicenseCreated="animation.term_license_created"
                    :termLicenseStatus="animation.term_license_status"
                    :termLicenseType="animation.term_license_type"
                    :termLicenseExpires="animation.license_expire_date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="user.expiredLicenses.length" class="row">
          <div class="images-wrapper col-12">
            <div class="row artwork-section-header">
              <div
                class="artwork-section-content col-12 d-flex justify-content-between align-items-center"
              >
                <div>
                  <h4 class="m-0">
                    EXPIRED LICENSES ({{ user.expiredLicenses.length }})
                  </h4>
                </div>
              </div>
            </div>
            <div
              class="row expired-row"
              v-for="item in user.expiredLicenses"
              :key="'expired-license-' + item.id"
            >
              <div class="col-12">
                <div class="row">
                  <div class="col-sm-1 col-6">
                    <img class="img-fluid" :src="item.thumbnail" />
                  </div>
                  <div class="col-sm-11 col-6">
                    <div class="row h-100">
                      <div
                        class="col-sm-2 expired-title d-flex align-items-center"
                      >
                        {{ item.type === "pro" ? "PRO file" : item.type }} #{{
                          item.artwork_id
                        }}
                      </div>
                      <div class="col-sm-6 d-flex align-items-center">
                        Expired: {{ item.license_expire_date }}
                      </div>
                      <div
                        class="col-sm-4 d-flex justify-content-end align-items-center"
                      >
                        <div>
                          <base-button
                            type="primary"
                            size="sm"
                            class="buy-button"
                            block
                            :loading="
                              expiredLicenseDownloadingId === item.artwork_id
                            "
                            @click="
                              downloadLicense(item.artwork_id, item.type, true)
                            "
                            ><i class="fas fa-download"></i> DOWNLOAD
                            LICENSE</base-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="images-wrapper col-12">
            <div
              v-if="
                user.claimedImages.length === 0 &&
                user.claimedAnimations.length === 0
              "
              class="no-images"
            >
              You haven't claimed any artwork yet.
              <router-link
                to="/store"
                @click.native="resetSearch"
                class="btn btn-sm btn-outline-primary mt-3"
                >BROWSE AVAILABLE ARTWORK</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { SectionHeader, ArtworkCard } from "../../components";
import { mapState } from "vuex";
import swal from "sweetalert2";
const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  name: "my-images-page",
  metaInfo: {
    title: "My Images - Art Grab",
  },
  components: {
    SectionHeader,
    ArtworkCard,
  },
  data() {
    return {
      expiredLicenseDownloadingId: null,
    };
  },
  methods: {
    resetSearch() {
      this.$store.commit("setSearchPage", 1);
    },
    downloadLicense(artwork_id, type) {
      this.expiredLicenseDownloadingId = artwork_id;
      this.axios
        .request({
          baseURL: apiBaseURL,
          url: "/api/artv1.1/photo/downloadtermlicense",
          responseType: "blob",
          method: "post",
          data: {
            id: artwork_id,
            is_animation: type === "animation",
            is_pro_file: type === "pro",
          },
        })
        .then((result) => {
          var filename = `Art-Grab-Term-Licensing-Agreement-${artwork_id}.pdf`;
          var blob = new Blob([result.data], { type: "application/pdf" });

          if (typeof window.navigator.msSaveBlob !== "undefined") {
            // IE workaround for "HTML7007: One or more blob URLs were
            // revoked by closing the blob for which they were created.
            // These URLs will no longer resolve as the data backing
            // the URL has been freed."
            window.navigator.msSaveBlob(blob, filename);
          } else {
            var blobURL = window.URL.createObjectURL(blob);
            var tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", filename);

            // Safari thinks _blank anchor are pop ups. We only want to set _blank
            // target if the browser does not support the HTML5 download attribute.
            // This allows you to download files in desktop safari if pop up blocking
            // is enabled.
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }

            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
          }
        })
        .catch((error) => {
          swal.fire({
            type: "error",
            title: "Oh no!",
            text: "Could not download the license file. Please try again or contact us for support. ",
            confirmButtonColor: "#000",
          });
        })
        .finally(() => {
          this.expiredLicenseDownloadingId = null;
        });
    },
  },
  mounted() {
    this.$store.commit("setLayout", "page-layout");
    this.$store.dispatch("getClaimedImages");
  },
  computed: {
    ...mapState(["user"]),
  },
};
</script>

<style scoped lang="scss">
#my-images {
  padding-top: 100px;

  .no-images {
    padding: 6.844rem 1rem;
    background: #f7f7f7;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .expired-row {
    padding: 12px 0;
    margin-left: 0;
    margin-right: 0;
    border-bottom: 1px solid #dadada;

    img {
      border-radius: 4px;
    }

    .expired-title {
      text-transform: capitalize;
    }
  }

  .artwork-section-header {
    margin-bottom: 20px;
    margin-left: 0;
    margin-right: 0;

    .artwork-section-content {
      padding: 0 0 10px;
      border-bottom: 1px solid #000;
    }
  }
}

@media (max-width: 991.98px) {
  #my-images {
    padding-top: 100px;
  }
}
</style>
